<div class="input-error">
  <ng-content></ng-content>
</div>
